import {
  isGroupRadius, isIndividualRadius, type RadialDistance, type RadiusProximity,
} from '~/_shared/types/proximity/proximity.types';
import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { getGroupRadiusProximityDetails } from '~/proximity/proximity.helpers';

export const getProximityRadius = (
  proximity: RadiusProximity,
  spreadsheetRowId?: SpreadsheetRowId,
): RadialDistance | null => {
  if (isGroupRadius(proximity) && spreadsheetRowId) { // we only support 1 circle, so if group, specificRowId needs to be set
    const radialDistance = getGroupRadiusProximityDetails(proximity, spreadsheetRowId);
    return {
      radius: radialDistance.radius,
      unit: radialDistance.unit,
    };
  }
  if (isIndividualRadius(proximity)) {
    return {
      radius: proximity.data.radius,
      unit: proximity.data.unit,
    };
  }
  return null;
};
